import React from 'react'
import { Container, Icon, Information, View } from './styled'
import { Eye, WarningCircle } from '@phosphor-icons/react'
export const Card = ({ onclick, data }) => {
  const name = data.Employee.User.UserInfo[0].name
  const sentAtDate = new Date(data.sent_at).toLocaleDateString()
  const sentAtTime = new Date(data.sent_at).toLocaleTimeString()

  return (
    <Container>
      <Icon className="Icon">
        <WarningCircle size={40} color="#770A00" weight="fill" />
      </Icon>
      <Information className="Information">
        <div>
          <span id="title">Não enviou código do sempre alerta</span>
        </div>
        <div>
          <span id="name">Seg. {name}</span>
          <span id="alert">
            Alerta emitido:{' '}
            <strong>
              {sentAtDate} - {sentAtTime}
            </strong>
          </span>
        </div>
      </Information>
      <View className="View" onClick={() => onclick(data.id)}>
        <Eye size={40} color="#770A00" weight="bold" />
      </View>
    </Container>
  )
}
